import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { Neo } from "@singularsystems/neo-react";
import { ReportCategory } from "../ReportCategory";
import AssetProjectionCriteria from "./AssetProjectionCriteria";

@NeoReport("AssetProjection", { category: ReportCategory.SystemReports })
export default class AssetProjectionReport extends Report<AssetProjectionCriteria> {

    constructor() {
        super(AssetProjectionCriteria);
    }

    public renderCriteria() {
        return <Neo.GridLayout>
            <div>
                <DateSelectionComponent criteria={this.criteria} />
                <Neo.FormGroup bind={this.criteria.meta.useNitAccountNumbers} label="Use NIT account numbers?" footerText="Whether 'Account Number' should be prefixed with NIT or DPA/DPL" />
            </div>
        </Neo.GridLayout>
    }
}